export const STATIC_CARD_HEADLINES = {
  AP_LESSON: 'WATCH',
  AP_WAIT_RESPONSE: 'RESPOND',
  OPTIONAL_PRACTICE: 'OPTIONAL PRACTICE',
};

const headline = STATIC_CARD_HEADLINES.AP_LESSON;
const period = 'Mon-Thu';
const liveStreamMessage = 'YouTube Livestream';

export const TODO_CARD_TYPES = {
  PRACTICE_EXAM: 'PRACTICE_EXAM',
  PROGRESS_CHECK: 'PROGRESS_CHECK',
  LEARNING_CHECKPOINT: 'LEARNING_CHECKPOINT',
  PERFORMANCE_TASK: 'PERFORMANCE_TASK',
  QUIZ: 'QUIZ',
  DAILY_VIDEO: 'DAILY_VIDEO',
  WELCOME_VIDEO: 'WELCOME_VIDEO',
  SPP: 'SPP',
};

export const TODO_CARD_LABELS = {
  [TODO_CARD_TYPES.PRACTICE_EXAM]: 'PRACTICE EXAM',
  [TODO_CARD_TYPES.LEARNING_CHECKPOINT]: 'LEARNING CHECKPOINT',
  [TODO_CARD_TYPES.PERFORMANCE_TASK]: 'PERFORMANCE TASK',
  [TODO_CARD_TYPES.PROGRESS_CHECK]: 'PROGRESS CHECK',
  [TODO_CARD_TYPES.QUIZ]: 'QUIZ',
  [TODO_CARD_TYPES.DAILY_VIDEO]: 'DAILY VIDEO',
  [TODO_CARD_TYPES.WELCOME_VIDEO]: 'WELCOME TO AP',
  [TODO_CARD_TYPES.SPP]: 'STUDENT PRACTICE',
};

export const TODO_CARDS_CONFIG = [
  {
    type: TODO_CARD_TYPES.PROGRESS_CHECK,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.PROGRESS_CHECK],
    header_bg: 'bg-blue-700',
    body_bg: 'bg-blue-100',
    icon: 'progress-check',
  },
  {
    type: TODO_CARD_TYPES.LEARNING_CHECKPOINT,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.LEARNING_CHECKPOINT],
    header_bg: 'bg-blue-700',
    body_bg: 'bg-blue-100',
    icon: 'progress-check',
  },
  {
    type: TODO_CARD_TYPES.PERFORMANCE_TASK,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.PERFORMANCE_TASK],
    header_bg: 'bg-blue-light-700',
    body_bg: 'bg-blue-light-100',
    icon: 'performance-task',
  },
  {
    type: TODO_CARD_TYPES.PRACTICE_EXAM,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.PRACTICE_EXAM],
    header_bg: 'bg-green-700',
    body_bg: 'bg-green-100',
    icon: 'practice-exam',
  },
  {
    type: TODO_CARD_TYPES.QUIZ,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.QUIZ],
    header_bg: 'bg-orange-700',
    body_bg: 'bg-orange-100',
    icon: 'my-quiz',
  },
  {
    type: TODO_CARD_TYPES.DAILY_VIDEO,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.DAILY_VIDEO],
    header_bg: 'bg-purple-700',
    body_bg: 'bg-purple-100',
    icon: 'play_circle',
  },
  {
    type: TODO_CARD_TYPES.WELCOME_VIDEO,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.WELCOME_VIDEO],
    header_bg: 'bg-yellow-500',
    body_bg: 'bg-yellow-100',
    icon: 'welcome_video_circle',
  },
  {
    type: TODO_CARD_TYPES.SPP,
    label: TODO_CARD_LABELS[TODO_CARD_TYPES.SPP],
    header_bg: 'bg-teal',
    body_bg: 'bg-teal-100',
    icon: 'spp',
  },
];

export const youtubeLinkBySubject = {
  1: {
    headline,
    staticDate: `${period}, 6:00PM-7:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847VRWTPXkDwxeVvNNfoKD7J',
  },
  2: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq484479U3Mvh2nUNvSUSPyZohj',
  },
  6: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847VchRdUdvbDPzsp9ResrjD',
  },
  7: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845Sy3UfnNh_PljzAptMR7MQ',
  },
  8: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845xKOY11PnkE7aqJC7-bYrd',
  },
  10: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4846HpniS9auPk8siwRF5LoPB',
  },
  11: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847-M3z5bOgGoX1fWVshEsLL',
  },
  12: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845w6_VxQLtAmVypmSMtTd0r',
  },
  13: {
    headline,
    staticDate: `${period}, 6:00PM-7:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845L7Yj9c1kkIfdskkaLOUzD',
  },
  14: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847IAo58jX32INd_UxDVW0YJ',
  },
  15: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq48471wZEJTgkJCJxOw2q1wmYM',
  },
  16: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq48450RQdBgdqj-a4J0eD9lrkw',
  },
  18: {
    headline,
    staticDate: `${period}, 6:00PM-7:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847gGLvmfXPT5pYZRqBqsqLN',
  },
  19: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4844xCVbFUawcSsJ_iOJ_3Cvt',
  },
  20: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847dhi0SrQsNup5c76p7m3Ve',
  },
  21: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847a2DzrJb-ftSzsICV5Gdi0',
  },
  23: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq48459FanuiZNHWzyvs8AfIEre',
  },
  25: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4844keKrijbR_EPKRNIW6hahV',
  },
  26: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4844oVJMjJ8YkD4mQIoMp4Cbu',
  },
  27: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4846e6QsN6lj_QzbOo-TDf86A',
  },
  29: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq48467T6PU5a6QwxNgUb5SgI9V',
  },
  30: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4844U91iotDP7n7brR_ovoSFB',
  },
  31: {
    headline,
    staticDate: `${period}, 6:00PM-7:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847NrGXhnmp6QnzSwknYH3SJ',
  },
  32: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4846hRB2oasV7sYAA4yW7VrbG',
  },
  33: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845u-QDW3bikMhC4uQsuYDpy',
  },
  34: {
    headline,
    staticDate: `${period}, 6:00PM-7:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845dmFXqxdQ3LBR2fxLgv0GM',
  },
  78: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845HXjP2hMrCCHw-koPsj7oY',
  },
  86: {
    headline,
    staticDate: `${period}, 4:00PM-5:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4844fvUz7G3obGEDqiz5q8G9L',
  },
  87: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847R2JKQ7-nYVhrnD2ajSG7Y',
  },
  88: {
    headline,
    staticDate: `${period}, 7:00PM-8:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847sWgSD6H0I18jdFzxNrvGj',
  },
  92: {
    headline,
    staticDate: `${period}, 6:00PM-7:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4847W5Jc1K3o99YHTGLx-L75m',
  },
  93: {
    headline,
    staticDate: `${period}, 5:00PM-6:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4845KrxuxxrWj4WM7oM6Wxl1m',
  },
  103: {
    headline,
    staticDate: `${period}, 6:00PM-7:00PM ET`,
    message: liveStreamMessage,
    link: 'https://youtube.com/playlist?list=PLoGgviqq4844vbwcKegJgIxSQyVHDzSXT',
  },
};

/**
 * @summary
 *   Static cards for exam decision, welcome video and welcome video response todos.
 *   Truncation thresholds for links within todo cards.
 *   Exam decision options.
 *
 * @desc Student carousel item schema (static and from /todos/student).
 * {Object.<string, number, function>} todoObj
 * {string} todoObj.headline Header text.
 * {string} todoObj.date Date string (formatted via dayjs.js).
 * {string} todoObj.link URL or path to navigate to.
 * {string} todoObj.message Text for anchor.
 * {string} todoObj.className Class name(s) to assign to parent element.
 * {string|function} todoObj.onClick Function or name of function (from props) for click event.
 * {number} todoObj.subject_id Subject ID associated with todo returned from /todos/student.
 */
export const APStudentCarousel = {
  ITEMS: {
    examItems: {
      decisionYes: {
        headline: 'EXAM REGISTRATION',
        message: "You're registered for the AP Exam.",
        onClick: 'getExamDecision',
      },
      decisionNo: {
        headline: 'EXAM REGISTRATION',
        message: "You're not currently registered for the AP Exam.",
        onClick: 'getExamDecision',
      },
      examOptIn: {
        headline: 'AP EXAM',
        message: 'Please indicate whether you are registering for the AP Exam.',
        className: 'urgent-todo',
        onClick: 'getExamDecision',
      },
      examOptOut: {
        headline: 'AP EXAM',
        message: 'You are registered for the AP Exam. Please confirm.',
        className: 'urgent-todo',
        onClick: 'getExamDecision',
      },
    },
    videoItems: {
      watchVideo: {
        headline: 'WATCH',
        date: '{registeredDate}',
        message: 'Welcome Video',
        subMessage: 'Hear from previous students',
        onClick: 'getWelcomeVideo',
      },
      videoResponse: {
        headline: 'RESPOND',
        date: '{completedViewAt}',
        message: 'Your Voice',
        subMessage: 'Share your perspective to help future AP students',
        onClick: 'getWelcomeVideoResponses',
      },
    },
    peCard: {
      headline: STATIC_CARD_HEADLINES.OPTIONAL_PRACTICE,
      message: 'Practice Answering Free-Response Exam Questions',
      className: 'pe-todo without-date',
      onClick: 'onPeCardClick',
    },
  },
  MAX_LINK_LENGTH: {
    WO_DATE: 75,
    W_DATE: 45,
  },
  EXAM_OPTIONS: {
    YES: 'yes',
    NO: 'no',
    DEFAULT: 'unknown',
  },
};

export const PreAPStudentCarousel = {
  ITEMS: {
    examItems: {
      decisionYes: {
        headline: 'EXAM REGISTRATION',
        message: "You're registered for the Pre-AP Exam.",
        onClick: 'getExamDecision',
      },
      decisionNo: {
        headline: 'EXAM REGISTRATION',
        message: "You're not currently registered for the Pre-AP Exam.",
        onClick: 'getExamDecision',
      },
      examOptIn: {
        headline: 'Pre-AP EXAM',
        message:
          'Please indicate whether you are registering for the Pre-AP Exam.',
        className: 'urgent-todo',
        onClick: 'getExamDecision',
      },
      examOptOut: {
        headline: 'Pre-AP EXAM',
        message: 'You are registered for the Pre-AP Exam. Please confirm.',
        className: 'urgent-todo',
        onClick: 'getExamDecision',
      },
    },
  },
  MAX_LINK_LENGTH: {
    WO_DATE: 75,
    W_DATE: 45,
  },
  EXAM_OPTIONS: {
    YES: 'yes',
    NO: 'no',
    DEFAULT: 'unknown',
  },
};

export const DEFAULT_EMPTY_STATIC_ITEMS = {
  pinned: [],
  carousel: [],
};
